import React from 'react'
import FormTable from '../../../Components/FormTable'

const AjouterTable = () => {
  return <FormTable />
}

export default AjouterTable
